export function useTransitionHeight(duration = 300) {
    const beforeEnter = (el: HTMLElement) => {
        el.style.height = "0";
        el.style.opacity = "0";
    };

    const enter = (el: HTMLElement, done: () => void) => {
        const height = el.scrollHeight;
        el.style.transition = `all ${duration}ms ease`;
        requestAnimationFrame(() => {
            el.style.height = `${height}px`;
            el.style.opacity = "1";
        });
        el.addEventListener(
            "transitionend",
            () => {
                el.style.height = "auto";
                done();
            },
            { once: true },
        );
    };

    const leave = (el: HTMLElement, done: () => void) => {
        const height = el.scrollHeight;
        el.style.height = `${height}px`;
        el.style.opacity = "1";
        void el.offsetHeight;

        el.style.transition = `all ${duration}ms ease`;
        requestAnimationFrame(() => {
            el.style.height = "0";
            el.style.opacity = "0";
        });

        el.addEventListener("transitionend", done, { once: true });
    };

    return { beforeEnter, enter, leave };
}
